import { FunctionComponent, useEffect, useState } from "react"
import styled from "styled-components"
import { HorizontalSpacer } from "../../atoms/spacers"
import { DeliveryMethod, Money, Line, Order } from "../../interfaces/SaleorTypes"
import { getFormattedPrice } from "../../../utils/cart-helpers"
import ConfirmationTerminalSection from "./ConfirmationTerminalSection"
import ConfirmationAccessorySection from "./ConfirmationAccessorySection"
import ConfirmationShippingSection from "./ConfirmationShippingSection"
import ConfirmationDataPlanSection from "./ConfirmationDataPlanSection"
import ConfirmationTopupSection from "./ConfirmationTopupSection"
import ConfirmationRentals from "./ConfirmationRentals"
import H1 from "../../atoms/typography/H1"
import BodyLarge from "../../atoms/typography/BodyLarge"
import { theme } from "../../theme"
import { getDateIn3BusinessDays } from "../../../utils/helpers"

interface ConfirmationSummaryProps {
  order: Order
  checkoutType: string
}

const MainContainer = styled.div`
  padding: 3em;
`

const HeaderWrapper = styled.div`
  margin-bottom: 1em;
`

const SubTotalContainer = styled.div<{ gradient: string }>`
  color: white;
  display: flex;
  background: #8191a1;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0.9em;
  row-gap: 0.5em;
  background-image: ${(props) => props.gradient};
`

const ConfirmationSummary: FunctionComponent<ConfirmationSummaryProps> = ({ order, checkoutType, ...props }) => {
  const [lines, setLines] = useState<Line[]>()
  const [deliveryMethod, setDeliveryMethod] = useState<DeliveryMethod>()
  const [status, setStatus] = useState<string>("")
  const [total, setTotal] = useState<Money>()
  const isRental = checkoutType === "rental"

  const selectedRentalDate = order.selectedRentalDate ?? getDateIn3BusinessDays()

  useEffect(() => {
    if (order) {
      setStatus(order.status)
      setLines(order.lines)
      setDeliveryMethod(order.deliveryMethod)
      setTotal(order.total.gross)
    }
  }, [order])

  return (
    <MainContainer>
      <HeaderWrapper>
        <H1>Summary</H1>
      </HeaderWrapper>
      {lines && <ConfirmationTerminalSection lines={lines} status={status} />}
      {lines && <ConfirmationAccessorySection lines={lines} status={status} />}
      {lines && <ConfirmationDataPlanSection lines={lines} status={status} />}
      {lines && <ConfirmationTopupSection lines={lines} status={status} />}
      {lines && <ConfirmationRentals lines={lines} selectedDate={selectedRentalDate} />}
      {deliveryMethod && <ConfirmationShippingSection shippingMethod={deliveryMethod} />}
      <HorizontalSpacer spacing={2} />
      <SubTotalContainer gradient={isRental ? theme.gradients.yellow : theme.gradients.blue}>
        <BodyLarge color="white">{`Estimated delivery time: ${
          isRental ? "3 business" : "30"
        } days from order confirmation`}</BodyLarge>
        {total && (
          <BodyLarge color={theme.colors.white}>
            Total:
            {status == "UNCONFIRMED" ? "TBD" : getFormattedPrice(total.amount, total.currency)}
          </BodyLarge>
        )}
      </SubTotalContainer>
    </MainContainer>
  )
}

export default ConfirmationSummary
